__turbopack_context__.v({
  "left": "arrowNavigator-module-scss-module__IyEyua__left",
  "right": "arrowNavigator-module-scss-module__IyEyua__right",
  "wrapper": "arrowNavigator-module-scss-module__IyEyua__wrapper",
});
